import useFetchData from './useFetchData'
import { getFamilyGroupsList } from '../services/notifications'

const fetchHasFamilyGroups = async () => {
  const groupsList = await getFamilyGroupsList()
  return groupsList.length > 0
}

export default function useNotifications() {
  const { data: hasFamilyGroups, loading: hasFamilyGroupsLoading } = useFetchData(fetchHasFamilyGroups, {
    initialData: false,
  })
  return {
    hasFamilyGroups,
    hasFamilyGroupsLoading,
  }
}
